import React, { useEffect, useState } from "react";
import Select, { ActionMeta, MultiValue } from "react-select";
import { useTranslation } from "react-i18next";

interface ISearchMultiSelectProps {
  data: { value: string; label: string }[];
  values: any;
  fieldName: string;
  placeholderText: string;
  onChange: (
    newValue: MultiValue<{ value: string; label: string }>,
    actionMeta: ActionMeta<{ value: string; label: string }>,
  ) => void;
}

const SearchMultiSelect: React.FC<ISearchMultiSelectProps> = ({
  data,
  values,
  fieldName,
  placeholderText,
  onChange,
}) => {
  const [darkTheme, setDarkTheme] = useState(
    localStorage.getItem("darkMode") === "true",
  );

  useEffect(() => {
    setDarkTheme(localStorage.getItem("darkMode") === "true");
  }, [localStorage.getItem("darkMode")]);

  const customStyles = {
    control: (base: any) => ({
      ...base,
      backgroundColor: darkTheme ? "#0f172a" : "#ffffff",
      borderColor: darkTheme ? "#334155" : "#cbd5e1",
      color: darkTheme ? "#e2e8f0" : "#0f172a",
      borderRadius: "0.5rem",
      minHeight: 40,
      boxShadow: "none",
      ":hover": {
        borderColor: darkTheme ? "#475569" : "#cbd5e1",
      },
    }),
    input: (base: any) => ({
      ...base,
      color: darkTheme ? "#e2e8f0" : "#2d3748",
    }),
    menu: (base: any) => ({
      ...base,
      backgroundColor: darkTheme ? "#2d3748" : "#fff",
      marginTop: 0,
    }),
    option: (base: any, state: { isFocused: boolean }) => ({
      ...base,
      backgroundColor: state.isFocused
        ? darkTheme
          ? "#4a5568"
          : "#edf2f7"
        : darkTheme
          ? "#2d3748"
          : "#fff",
      color: darkTheme ? "#e2e8f0" : "#2d3748",
      ":active": {
        backgroundColor: darkTheme ? "#4a5568" : "#e2e8f7",
      },
    }),
    multiValue: (base: any) => ({
      ...base,
      backgroundColor:
        fieldName === "tags"
          ? darkTheme
            ? "#00A3E0"
            : "#007CB0"
          : darkTheme
            ? "#43B02A"
            : "#26890D",
    }),
    multiValueLabel: (base: any) => ({
      ...base,
      color: "#e2e8f0",
    }),
    multiValueRemove: (base: any) => ({
      ...base,
      color: darkTheme ? "#e2e8f0" : "#2d3748",
      ":hover": {
        backgroundColor: darkTheme ? "#718096" : "#cbd5e0",
        color: darkTheme ? "#1a202c" : "#2d3748",
      },
    }),
    placeholder: (base: any) => ({
      ...base,
      color: darkTheme ? "#9ca3af" : "#9CA3AF",
      fontSize: "14px",
    }),
  };

  return (
    <Select
      isMulti
      options={[...data].sort((a, b) => a.label.localeCompare(b.label))}
      value={data.filter((option) => values.includes(option.value))}
      onChange={onChange}
      placeholder={placeholderText}
      className={fieldName === "keywords" ? "mb-2" : ""}
      styles={customStyles}
    />
  );
};

export { SearchMultiSelect };
